<template>
  <div class="targetType_w overflow_hidden">

    <CardHead title="项目类型">
      <div slot="oper">
        <span class="c_1A1A1A" @click="onMoreClick">更多>></span>
      </div>
    </CardHead>

    <div class="target-list content_w d_flex flex_wrap fz14 c_4D4D4D">
      <div v-for="item in list" :key="item.key" class="type_i text_ellipsis flex_basis_50" @click="onClickType(item)">{{ item.value }}</div>
    </div>

  </div>
</template>

<script>
import CardHead from '@/components/template/CardHead.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    CardHead
  },
  computed: {
    ...mapGetters(['siteInfo']),
    list(){
      return this.siteInfo.tradeKinds.slice(0,6)
    }
  },
  methods: {
    //
    onClickType(item) {
      this.$router.push({
        name: 'tradeHall',
        params: {
          tabType:'tradeKind',
          tradeKind:item.key,
          value:item.value
        }
      })
    },
    // 更多
    onMoreClick(){
      this.$router.push({
        name: 'tradeHall',
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.targetType_w{
    width: 275px;
    // height: 122px;
    padding: 0 10px;
    border: 1px solid #E6E6E6;
    box-sizing: border-box;
    .content_w{
      padding: 5px 0;
      .type_i{
        padding: 10px ;
        box-sizing: border-box;
        &:hover{
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }
    .target-list{
      height: 77px;
      align-content: flex-start;
    }
}
</style>
